import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  BANNER_TYPE_INFO,
  FRONTM_DOMAIN,
  FRONTM_BOT_ID,
} from "../../../utils/constants";
import {
  getAuthData,
  storeAuthData,
} from "../../../services/storage/LocalStorage";
import { changeConversation } from "../../../state/actions/chats";
import { activateEnterpriseBots } from "../../../services/api/BotApiServices";
import { setSelectedDomain } from "../../../state/actions/domain";
import { loadAllDomainsListInLFStorage, storeDomainSelected } from "../../../services/storage/LFStorage";
import { showToast } from "../../ui/toaster";
import { addAppNotification } from "../../../state/actions/appNotifications";

import ModalCancelButton from '../../ui/Modals/ModalMessages/ModalCancelButton';
import ModalConfirmButton from '../../ui/Modals/ModalMessages/ModalConfirmButton';
import webSocketApiService from "../../../services/socket/wsApiServices";


const ActivateEnterpriseBots = ({
  cancel,
  isLicenseValid = true,
  onFormSubmit,
}) => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const [code, setCode] = useState("");
  const [error, setError] = useState(false);

  const timeLine = useSelector((state) => state.chats.timeLine);
  const selectedDomain = useSelector((state) => state.domain.selectedDomainDetails);
  const userId = useSelector((state) => state.user.userId);
  const userDomain = selectedDomain?.userDomain;
  let domainLists = useSelector((state) => state?.domain?.domains);
 
  const selectDomain = async (data) => {
    await webSocketApiService.UpdateLastLoggedInDomain({ userDomain: data.userDomain }).then(() => {
      if (timeLine && timeLine.length === 0) {
      } else {
        const index = timeLine.findIndex(
          (conversation) =>
            conversation.bot && conversation.bot.botId === FRONTM_BOT_ID
        );
        if (index !== -1) {
          dispatch(changeConversation(timeLine[index], true));
        }
      }
      dispatch(setSelectedDomain(data));
      history.push("/app/home");
    })
      .catch(console.log)
  };

  const updateLoggedStateForRoles = (updatedDomain) => {
    const authData = getAuthData();
    authData.user.domains.forEach((item) => {
      if (item.domain === updatedDomain.userDomain) {
        item.roles = updatedDomain.roles;
      }
    });
    storeAuthData(authData);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setError(false);

    if (!code || !code.length) {
      setError("Please enter code");
      return;
    }

    activateEnterpriseBots(code, userId)
      .then((response) => {
        console.log('response', response)
        if (response.errorMessage) {
          setError(response.errorMessage);
        } else if (response.content && response.content[0] == null) {
          setError("Incorrect code. Try again");
        } else {
          const content = response.content;
          const newDomainName = content.find((domain) => !domainLists.some((d) => d.userDomain === domain.userDomain))?.name || '';
          showToast('success', `You are now signed in to ${newDomainName}.`);
          dispatch(addAppNotification(
            `You are now signed in to ${newDomainName}.`,
            BANNER_TYPE_INFO
          ));

          const newAddedDomain = content.find((domain) => !domainLists.some((d) => d.userDomain === domain.userDomain)) || '';

          setTimeout(() => {
            const corporateDomains = content.filter(
              (domain) => domain.userDomain !== FRONTM_DOMAIN
            );
            loadAllDomainsListInLFStorage(corporateDomains);
           
            dispatch(setSelectedDomain(newAddedDomain));
            updateLoggedStateForRoles(newAddedDomain);
            storeDomainSelected(newAddedDomain);
            selectDomain(newAddedDomain);
          }, 3000);

          onFormSubmit?.();
        }
      })
      .catch((error) => {
        console.log("Error activating enterprise bots:", error);
        setError(
          error.message || error.errorMessage || "Sorry something went wrong. Please contact our support"
        );
      });
  };

  return (
    <div className="page-wrapper d-flex flex align-items-center">
      <div className="container">
        <div className="row align-self-center">
          <div className={`mb-3 ${userDomain}_font text-gray-300`}>
            Please enter your business license key.
          </div>
          <div className="col-lg-12 col-md-12 col-12">
            <div className="m-2">
              <form onSubmit={onSubmit}>
                <div className="form-group" style={{ marginBottom: "2rem" }}>
                  <input
                    id="license-code"
                    placeholder="License Key"
                    type="text"
                    className="border border-gray-100 rounded-7 w-full py-3 px-3 text-black h-12 focus:outline-none"
                    onChange={(e) => setCode(e.target.value)}
                    value={code}
                    autoComplete="off"
                  />
                  {error && (
                    <div className="d-flex justify-content-end mt-1">
                      <span
                        style={{
                          backgroundColor: "#E5453B",
                          color: "#fff",
                          padding: "2px 5px",
                          borderRadius: "0 5px 5px 5px",
                          lineHeight: 1,
                        }}
                        className={`${userDomain}_font`}
                      >
                        <small>{error}</small>
                      </span>
                    </div>
                  )}
                </div>
                <hr />
                <div className="pt-2 flex justify-center border-t">
                  {isLicenseValid && (
                    <ModalCancelButton label="Cancel" onClickFn={cancel} />
                  )}
                  <ModalConfirmButton label="Submit" onClickFn={onSubmit} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivateEnterpriseBots;
